<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="名称：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="图片：" prop="imgpath" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    action=""
                    disabled>
                    <img v-if="model.imgpath" :src="model.imgpath" class="upImg" style="width: 375px;height: 225px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 375px;height: 225px;line-height: 225px"></i>
                </el-upload>
                <span class="tips">建议尺寸：750px * 225px</span>
            </el-form-item>
            <el-form-item label="跳转地址：" prop="pagepath">
                <span>{{model.pagepath}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="是否显示：" prop="isshow">
                <span>{{transEnu(model.isshow,'yesNo')}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'

export default {
    name: "bannerInfo",
    mixins: [editutil],
    data() {
        return {
            model: {
                name: '',
                imgpath: '',
                pagepath: '',
                order_index: '',
                isshow: ''
            },
            getObj:{
                url:'/api/admin/banner/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
        }
    },
    methods: {
        formateData(){
            this.model.isshow = this.model.isshow+""
        }
    }
};
</script>